import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DurationToRelativeFormatPipeModule } from 'src/app/pipes/durationToRelativeFormat/duration-pipe/duration-pipe.module';
import { SharedTileModule } from '../shared/shared-tile.module';
import { NdtWaitTimesGraphTileComponent } from './ndt-wait-times-graph-tile.component';

@NgModule({
   declarations: [NdtWaitTimesGraphTileComponent],
   imports: [CommonModule, SharedTileModule, MatIconModule, DurationToRelativeFormatPipeModule],
   exports: [NdtWaitTimesGraphTileComponent],
})
export class NdtWaitTimesGraphTileModule {}
